<template>
  <div>
    <top-header-info></top-header-info>
    <top-logo state="1" :searchName="$route.query.search"></top-logo>
    <right-nav></right-nav>
    <home-nav></home-nav>

    <div class="products-wrap">
      <div class="w">
        {{ curCategory }}
        <!-- hideWarp -->
        <div class="site-nav" v-if="curCategory">
          <router-link :to="{ name: 'index' }">首页</router-link>>
          <router-link
            :to="{ name: 'category-home', query: { type: curCategory.type } }"
            >{{ curCategory.name }}</router-link
          >
        </div>
        <div class="banner" v-if="all_rates.length > 0 && type == 'discount'">
          <img src="@/assets/images/zhekouBanner.png" alt />
        </div>
        <div class="filterList">
          <!-- <div class="all" @click="goCategory(null)">首页</div> -->
          <div @click="clearCheck" style="cursor:pointer">全部结果</div>
          <div class="classifyBox" v-if="oneLevelClassify.length > 0">
            <div class="trigger">
              {{ oneLevelClassify[0].label }}<i class="el-icon-arrow-down"></i>
            </div>
            <ul>
              <li
                v-for="(item, index) in oneLevelClassify"
                :key="item.value"
                @click="clickClassifyOption(item, index)"
                :style="{ color: index == 0 ? '#CCCCCC' : '#666666' }"
              >
                {{ item.label }}
              </li>
            </ul>
          </div>
          <div class="classifyBox" v-if="twoLevelClassify.length > 0">
            <div class="trigger">
              {{ twoLevelClassify[0].label }}<i class="el-icon-arrow-down"></i>
            </div>
            <ul>
              <li
                v-for="(item, index) in twoLevelClassify"
                :key="item.value"
                @click="clickClassifyOption(item, index)"
                :style="{ color: index == 0 ? '#CCCCCC' : '#666666' }"
              >
                {{ item.label }}
              </li>
            </ul>
          </div>
          <div
            v-for="(item, key) in filterBoxObj"
            :key="item.name"
            class="filterListBox"
          >
            <span>{{ getFilterOption(key) }}</span>
            :
            <span class="value">{{ item.name }}</span>
            <i class="el-icon-close" @click="closeOption(item, key)"></i>
          </div>
          <div class="List" v-if="categoryArr.length > 0">
            <div
              class="item"
              @click="goCategory(item)"
              v-for="item in categoryArr"
              :key="item.category_id"
            >
              <i class="el-icon el-icon-arrow-right" />
              <span>{{ item.name }}</span>
            </div>
          </div>
          <div class="search" v-else>
            <i class="el-icon el-icon-arrow-right" />
            <span>{{ search }}</span>
          </div>
          <div
            v-if="categoryArr.length > 0"
            @click="clearCategory"
            class="clear-category"
          >
            重置分类
          </div>
          <div
            @click="clearCheck"
            class="emptyFilter"
            v-if="JSON.stringify(filterBoxObj) !== '{}'"
          >
            清空筛选
          </div>
          <!-- <div>
            <i class="el-icon el-icon-arrow-right" />
            {{search}}
          </div>
          <div class="clear">清空筛选</div>-->
          <!-- <div class="showFilter" @click="setFilterNum">
            {{ filterNum == "0px" ? "打开筛选" : "收起筛选" }}
            <i v-if="filterNum === '0px'" class="el-icon-arrow-up" />
            <i v-else class="el-icon-arrow-down"></i>
          </div> -->
          <div class="showFilter" @click="isFiltersShow = !isFiltersShow">
            {{ !isFiltersShow ? "打开筛选" : "收起筛选" }}
            <i v-if="!isFiltersShow" class="el-icon-arrow-up" />
            <i v-else class="el-icon-arrow-down"></i>
          </div>
        </div>
        <!-- <div class="filters" :style="'height:' + filterNum"> -->
        <div class="filters">
          <el-row class="category_wrap">
            <div
              v-if="!curCategory && !hideWarp"
              :style="{
                display: !isFiltersShow ? 'none' : 'block'
              }"
            >
              <el-col
                :span="2"
                style="text-align: left;color: #999999;text-indent: 12px;"
                class="marginTop"
                v-if="category.length > 0 && !filterBoxObj['checkAll']"
                >平台:</el-col
              >
              <el-col
                :span="22"
                class="marginTop optionBox"
                v-if="category.length > 0 && !filterBoxObj['checkAll']"
              >
                <!-- <el-checkbox-group
                  v-model="checkAll"
                  v-if="category.length > 0"
                >
                  <el-checkbox
                    class="colWdith"
                    v-for="(item, index) in category"
                    :key="index"
                    :label="item.value"
                    >{{ item.label }}</el-checkbox
                  >
                </el-checkbox-group> -->
                <div class="optionlist">
                  <ul>
                    <li
                      v-for="(item, index) in category"
                      :key="index"
                      @click="clickOption($event, item, 'checkAll')"
                    >
                      <i>
                        <b class="el-icon-check"></b>
                      </i>
                      {{ item.label }}
                    </li>
                  </ul>
                  <span @click="changeCheckBox($event)">多选+</span>
                </div>
                <div class="optionBtns">
                  <el-button
                    size="mini"
                    @click="comfirmCheckBox($event, 'checkAll')"
                    :disabled="checkAll.length == 0"
                    type="danger"
                    >确定</el-button
                  >
                  <el-button
                    size="mini"
                    @click="cancelCheckBox($event, 'checkAll')"
                  >
                    取消
                  </el-button>
                </div>
              </el-col>
              <el-col
                class="line"
                :span="24"
                v-if="category.length > 0 && !filterBoxObj['checkAll']"
              ></el-col>
              <el-col
                :span="2"
                style="text-align: left;color: #999999;text-indent: 12px;"
                class="marginTop"
                v-if="brandNames.length > 0 && !filterBoxObj['brands_name']"
                >品牌:</el-col
              >
              <el-col
                :span="22"
                v-if="brandNames.length > 0 && !filterBoxObj['brands_name']"
                class="marginTop optionBox"
              >
                <ul class="letterSearch" v-if="changeBrand">
                  <li
                    v-for="(item, index) in letterSearchList"
                    :key="item.py"
                    @mouseenter="hoverLetterSearch(index)"
                    :class="index == letterSearchActivedIndex ? 'actived' : ''"
                  >
                    {{ item.py }}
                  </li>
                </ul>
                <!-- <el-checkbox-group
                  v-model="brands_name"
                  class="maxHeight"
                  v-if="changeBrand"
                >
                  <el-checkbox
                    class="colWdith"
                    v-for="(item, index) in letterSearchList[
                      letterSearchActivedIndex
                    ].data"
                    :key="index"
                    :label="item.value"
                    >{{ item.value }}</el-checkbox
                  >
                </el-checkbox-group>
                <el-checkbox-group
                  v-model="brands_name"
                  class="maxHeight"
                  v-else
                >
                  <el-checkbox
                    class="colWdith"
                    v-for="(item, index) in brandNames"
                    :key="index"
                    :label="item.value"
                    >{{ item.value }}</el-checkbox
                  >
                </el-checkbox-group> -->
                <div class="optionlist">
                  <ul v-if="changeBrand" class="brandList">
                    <li
                      v-for="(item, index) in letterSearchList[
                        letterSearchActivedIndex
                      ].data"
                      :key="index"
                      @click="clickOption($event, item, 'brands_name')"
                      :style="{
                        backgroundImage: brands_name.includes(item.value)
                          ? `url(${payBg})`
                          : '',
                        color: brands_name.includes(item.value) ? '#e23a41' : ''
                      }"
                    >
                      <img :src="item.logo" alt="" v-if="item.logo" />
                      {{ item.value }}
                    </li>
                  </ul>
                  <ul v-else class="brandList">
                    <li
                      v-for="(item, index) in brandNames"
                      :key="index"
                      @click="clickOption($event, item, 'brands_name')"
                      :style="{
                        backgroundImage: brands_name.includes(item.value)
                          ? `url(${payBg})`
                          : '',
                        color: brands_name.includes(item.value) ? '#e23a41' : ''
                      }"
                    >
                      <img :src="item.logo" alt="" v-if="item.logo" />
                      {{ item.value }}
                    </li>
                  </ul>
                  <span @click="moreBrandName" style="right:60px;">
                    {{ changeBrand ? "收起" : "更多" }}
                    <i
                      :class="
                        changeBrand ? 'el-icon-arrow-up' : 'el-icon-arrow-down'
                      "
                      style="margin-left:-5px"
                    ></i>
                  </span>
                  <span
                    @click="
                      if (!changeBrand) moreBrandName();
                      changeCheckBox($event);
                    "
                    >多选+</span
                  >
                </div>
                <div class="optionBtns">
                  <el-button
                    size="mini"
                    @click="comfirmCheckBox($event, 'brands_name')"
                    :disabled="brands_name.length == 0"
                    type="danger"
                    >确定</el-button
                  >
                  <el-button
                    size="mini"
                    @click="
                      moreBrandName();
                      cancelCheckBox($event, 'brands_name');
                    "
                  >
                    取消
                  </el-button>
                </div>
              </el-col>
              <el-col
                class="line"
                :span="24"
                v-if="brandNames.length > 0 && !filterBoxObj['brands_name']"
              ></el-col>
              <el-col
                :span="2"
                style="text-align: left;color: #999999;text-indent: 12px;"
                class="marginTop"
                v-if="
                  all_categroy.length > 0 && this.twoLevelClassify.length == 0
                "
                >分类:</el-col
              >
              <el-col
                :span="22"
                v-if="
                  all_categroy.length > 0 && this.twoLevelClassify.length == 0
                "
                class="marginTop optionBox"
              >
                <!-- <el-checkbox-group
                  v-model="small_categroy"
                  class="maxHeight"
                  :class="changeMore ? 'scroll' : ''"
                >
                  <el-checkbox
                    class="colWdith"
                    v-for="(item, index) in all_categroy"
                    :key="index"
                    :label="item.value"
                    >{{ item.label }}</el-checkbox
                  >
                </el-checkbox-group> -->
                <div class="optionlist">
                  <ul>
                    <li
                      v-for="(item, index) in all_categroy"
                      :key="index"
                      @click="clickClassifyOption(item)"
                      class="classify"
                    >
                      <i><b class="el-icon-check"></b></i> {{ item.label }}
                    </li>
                  </ul>
                  <span v-if="old_categroy.length > 10" @click="moreCategroy">
                    {{ changeMore ? "收起" : "更多" }}
                    <i
                      :class="
                        changeMore ? 'el-icon-arrow-up' : 'el-icon-arrow-down'
                      "
                      style="margin-left:-5px"
                    ></i>
                  </span>
                  <!-- <span
                    @click="
                      moreCategroy();
                      changeCheckBox($event);
                    "
                    >多选+</span
                  > -->
                </div>
                <!-- <div class="optionBtns">
                  <el-button
                    size="mini"
                    @click="comfirmCheckBox($event, 'small_categroy')"
                    :disabled="small_categroy.length == 0"
                    type="danger"
                    >确定</el-button
                  >
                  <el-button size="mini" @click="cancelCheckBox($event,'small_categroy')">
                    取消
                  </el-button>
                </div> -->
              </el-col>
              <el-col
                class="line"
                :span="24"
                v-if="
                  all_categroy.length > 0 && this.twoLevelClassify.length == 0
                "
              ></el-col>
              <el-col
                :span="2"
                style="text-align: left;color: #999999;text-indent: 12px;"
                v-if="all_rates.length > 0 && !filterBoxObj['rates']"
                class="marginTop"
                >折扣:</el-col
              >
              <el-col
                :span="22"
                class="marginTop optionBox"
                v-if="all_rates.length > 0 && !filterBoxObj['rates']"
              >
                <!-- <el-checkbox-group v-model="rates">
                  <el-checkbox
                    v-for="item in all_rates"
                    :key="item.value"
                    :label="item.value"
                    @change="reateChange($event, item.label)"
                    >{{ item.label }}</el-checkbox
                  >
                </el-checkbox-group> -->
                <div class="optionlist">
                  <ul>
                    <li
                      v-for="(item, index) in all_rates"
                      :key="index"
                      @click="clickOption($event, item, 'rates')"
                    >
                      <i><b class="el-icon-check"></b></i> {{ item.label }}
                    </li>
                  </ul>
                  <span @click="changeCheckBox($event)">多选+</span>
                </div>
                <div class="optionBtns">
                  <el-button
                    size="mini"
                    @click="comfirmCheckBox($event, 'rates')"
                    :disabled="rates.length == 0"
                    type="danger"
                    >确定</el-button
                  >
                  <el-button
                    size="mini"
                    @click="cancelCheckBox($event, 'rates')"
                  >
                    取消
                  </el-button>
                </div>
                <!-- <span class="more" v-if="discounts.length>10" @click="moreCategroy">
              {{changeMore?'收起':'更多'}}
              <span>{{changeMore?'-':'+'}}</span>
                </span>-->
              </el-col>
              <el-col
                class="line"
                :span="24"
                v-if="all_rates.length > 0 && !filterBoxObj['rates']"
              ></el-col>

              <el-col
                :span="2"
                style="text-align: left;color: #999999;text-indent: 12px;"
                class="marginTop"
                v-if="attrs.length > 0"
              >
                高级选项:
              </el-col>
              <el-col
                :span="22"
                class="advancedOptions"
                v-if="attrs.length > 0"
              >
                <ul>
                  <li
                    v-for="(item, index) in attrs"
                    :key="index"
                    @mouseleave="mouseleaveEvent('options', $event)"
                    @mouseenter="mouseEnterEvent('options', item.value)"
                    :class="{ active: advancedOptionsActive == item.value }"
                    :data-index="index"
                  >
                    <span class="name" :title="item.value">
                      {{ item.value }}
                    </span>
                    <i class="el-icon-arrow-down"></i>
                  </li>
                </ul>
              </el-col>

              <el-col
                :span="24"
                class="contentAdvancedOptions"
                v-if="attrs.length > 0"
              >
                <div
                  class="contentAdvancedOptions-item"
                  v-for="(item, index) in attrs"
                  :key="index"
                  :style="{
                    display:
                      advancedOptionsActive == item.value ? 'flex' : 'none',
                    top: calculatePosition(index, attrs.length)
                  }"
                  @mouseleave="mouseleaveEvent('optionsList', $event)"
                  @mouseenter="mouseEnterEvent('optionsList', item.value)"
                >
                  <div class="contentAdvancedOptions-list">
                    <ul>
                      <li
                        v-for="(item2, index2) in item.values"
                        :key="index2"
                        @click="clickOption2($event, item2, item.value)"
                      >
                        <i><b class="el-icon-check"></b></i> {{ item2.value }}
                      </li>
                    </ul>
                    <span @click="changeCheckBox($event)">多选+</span>
                  </div>
                  <div class="contentAdvancedOptions-btn">
                    <el-button
                      size="mini"
                      type="danger"
                      @click="comfirmCheckBox2($event, item.value)"
                      >确定</el-button
                    >
                    <el-button size="mini" @click="cancelCheckBox($event)">
                      取消
                    </el-button>
                  </div>
                </div>
              </el-col>
              <el-col class="line" :span="24" v-if="attrs.length > 0"></el-col>
            </div>
            <!-- <is-empty v-else></is-empty> -->
            <!-- <el-col :span="8" :offset="10">
              <div class="_btn _denger _dengerBg" @click="serach">筛选</div>
              <div class="_btn _denger" @click="clearCheck">重置</div>
            </el-col> -->
          </el-row>
        </div>
        <div class="cate-nav-wrap">
          <el-row v-for="item in curCategories" :key="item.category_id">
            <a class="category-name">{{ item.name }}</a>
            <div class="cate-nav">
              <routerLink
                :class="{ actived: i.category_id == $route.query.category_id }"
                :to="{
                  name: 'products-list',
                  query: { type: curCategory.type, category_id: i.category_id }
                }"
                @click.native="
                  currentList = 0;
                  clearList();
                  initData();
                "
                v-for="i in item.categories"
                :key="i.category_id"
                >| {{ i.name }}</routerLink
              >
            </div>
          </el-row>
        </div>
        <div class="filter-wrap w">
          <div class="filter">
            <span
              :class="{ actived: currentFilter === 0 }"
              @click="
                currentFilter = 0;
                clearFilter();
                initData();
              "
            >
              综合
              <i class="el-icon el-icon-up"></i>
            </span>

            <span
              :class="{ actived: currentFilter === 2 }"
              @click="
                currentFilter = 2;
                clearFilter();
                changePriceFilter();
                initData();
              "
            >
              价格&nbsp;&nbsp;&nbsp;
              <i
                class="el-icon-caret-top"
                :class="{ actived: priceFilter === 0 && currentFilter === 2 }"
              ></i>
              <i
                class="el-icon-caret-bottom"
                :class="{ actived: priceFilter === 1 && currentFilter === 2 }"
              ></i>
            </span>

            <span
              :class="{ actived: currentFilter === 1 }"
              @click="
                currentFilter = 1;
                clearFilter();
                initData();
              "
            >
              销量
              <i class="el-icon el-icon-up"></i>
            </span>

            <span
              v-if="!discount_zone"
              :class="{ actived: currentFilter === 3 }"
              @click="
                currentFilter = 3;
                clearFilter();
                initData();
              "
            >
              最新
              <i class="el-icon el-icon-up"></i>
            </span>
            <span
              v-else
              :class="{ actived: currentFilter === 5 }"
              @click="
                currentFilter = 5;
                discountFilter = discountFilter === 0 ? 1 : 0;
                clearFilter();
                initData();
              "
            >
              折扣&nbsp;&nbsp;&nbsp;
              <i
                class="el-icon-caret-top"
                :class="{
                  actived: discountFilter === 0 && currentFilter === 5
                }"
              ></i>
              <i
                class="el-icon-caret-bottom"
                :class="{
                  actived: discountFilter === 1 && currentFilter === 5
                }"
              ></i>
            </span>

            <span
              :class="{ actived: currentFilter === 4 }"
              @click="
                currentFilter = 4;
                clearFilter();
                initData();
              "
            >
              好评度
              <i class="el-icon el-icon-up"></i>
            </span>

            <el-input
              placeholder="¥ "
              v-model="minPrice"
              style="margin-left: 20px;"
            ></el-input>
            <span style="border: none; background: none">-</span>
            <el-input placeholder="¥ " v-model="maxPrice"></el-input>

            <div class="mysearch-wrap">
              <span
                class="serach"
                @click="
                  clearFilter();
                  initData();
                "
                >搜索</span
              >
              <!-- <el-input placeholder="在结果中搜索"  v-model="minKeyword"></el-input> -->
              <!-- <i class="el-icon el-icon-mysearch" @click="currentPage=0;productsList=[];initData()"></i> -->
            </div>
            <div class="mypage-wrap">
              <mini-pagination
                @current-change="handleCurrentChange"
                :currentPage="currentPage"
                :pageCount="pageCount"
              ></mini-pagination>
            </div>

            <div class="empty" style="width: 300px;"></div>

            <div class="address">
              配送至：
              <el-input
                v-model="address"
                readonly
                @click.native="showSelectAddress"
              ></el-input>
              <address-tree
                v-if="isShowSelectAddress"
                @setAddress="setAddress"
              ></address-tree>
              <i class="el-icon-arrow-down"></i>
            </div>

            <div class="selectDeliveryMode" v-if="all_factory_ships.length > 0">
              <el-checkbox-group v-model="filter_factory_ships">
                <el-checkbox
                  v-for="(item, index) in all_factory_ships"
                  @change="
                    currentPage = 1;
                    initData();
                  "
                  :key="index"
                  :label="item.value"
                  >{{ item.label }}
                  <i
                    class="el-icon-arrow-down"
                    v-if="index == 0 && all_factory_ships.length !== 1"
                  ></i>
                </el-checkbox>
              </el-checkbox-group>
            </div>
            <div class="selected-postage">
              <el-checkbox
                v-model="selected_postage"
                @change="
                  currentPage = 1;
                  initData();
                "
                >包邮</el-checkbox
              >
            </div>
          </div>
        </div>
        <el-row class="product-list" v-loading="productLoading">
          <el-col
            :span="6"
            v-for="item in productsList"
            :key="item.product_id"
            @click.native="goToGoosDetail(item.product_id, item.sku)"
          >
            <div>
              <img
                class="product-img"
                :src="item.image ? item.image : defaultGoods"
                alt="goods"
              />
            </div>
            <div class="goods-description">
              <span v-if="item.supplier == 'sbz'" class="identify sbz">
                <span class="supply-text">上班族自营</span>
              </span>
              <span v-if="item.supplier == 'jd'" class="identify jd">
                <span class="supply-text">京东直供</span>
              </span>
              <span v-if="item.supplier == 'suning'" class="identify sn">
                <span class="supply-text">苏宁易购</span>
              </span>
              <span v-if="item.supplier == 'wangyi'" class="identify wy">
                <span class="supply-text">网易严选</span>
              </span>
              <span v-if="item.identify_type == '天猫超市'" class="identify tm">
                <span class="supply-text">天猫超市</span>
              </span>
              <span class="name faster" v-html="item.name"></span>
            </div>
            <div class="good-comment">
              <div
                v-if="
                  item.product_comment_summary &&
                    item.product_comment_summary.comment_count === 0
                "
              ></div>
              <div
                v-else-if="
                  item.product_comment_summary &&
                    item.product_comment_summary.comment_count >= 10000
                "
              >
                <span class="comment-highlight">
                  {{
                    parseInt(
                      item.product_comment_summary.comment_count / 10000
                    )
                  }}万+
                </span>
                <span>条评价</span>
                <span>好评度:</span>
                <span class="comment-highlight"
                  >{{
                    parseFloat(
                      (item.product_comment_summary.good_rate * 100).toFixed(2)
                    )
                  }}%</span
                >
              </div>
              <div
                v-else-if="
                  item.product_comment_summary &&
                    item.product_comment_summary.comment_count < 10000
                "
              >
                <span class="comment-highlight">
                  {{ item.product_comment_summary.comment_count }}
                </span>
                <span>条评价</span>
                <span>好评度:</span>
                <span class="comment-highlight"
                  >{{
                    parseFloat(
                      (item.product_comment_summary.good_rate * 100).toFixed(2)
                    )
                  }}%</span
                >
              </div>
            </div>
            <el-row class="goods-price">
              <el-col :span="12">
                {{ item.special | jifen }}
                <span
                  class="price_format"
                  v-if="isFalse(item.price, item.special)"
                  >{{ item.price | jifen }}</span
                >
                <span class="dis_rate_text" v-show="item.dis_rate_text">
                  {{ item.dis_rate_text }}
                </span>
              </el-col>
              <el-col :span="12">
                <el-button
                  @click.stop="
                    addToCart(item.product_id, item.minimum, item.sku)
                  "
                >
                  <i class="el-icon el-icon-shopping"></i>
                </el-button>
              </el-col>
            </el-row>
            <div class="goods-distribution">
              <span class="supply-text-jd" v-if="item.supplier == 'jd'">
                京东自营
              </span>
              <span
                class="supply-text"
                v-if="item.factory_ship_text"
                :class="item.supplier"
              >
                {{ item.factory_ship_text }}
              </span>
              <span class="supply-text by" v-if="item.free_shipping_text"
                >包邮</span
              >
            </div>
            <img
              v-if="item.can_buy_status === 3"
              src="../../assets/images/not_enough.png"
              class="not-enough"
              alt=""
            />
            <img
              v-else-if="item.can_buy_status === 2"
              src="../../assets/images/no_site.png"
              class="not-enough"
              alt=""
            />
          </el-col>
        </el-row>
        <is-empty v-if="isEmpty"></is-empty>
        <pagination
          @current-change="handleCurrentChange"
          :currentPage="currentPage"
          :pageCount="pageCount"
        ></pagination>
      </div>
    </div>

    <bottom-content></bottom-content>
  </div>
</template>
<script>
import TopHeaderInfo from "@/components/top-header-info";
import TopLogo from "@/components/top-logo";
import RightNav from "@/components/right-nav";
import BottomContent from "@/components/bottom-content";
import HomeNav from "@/components/home-nav";
import AddressTree from "@/components/address-tree";
import IsEmpty from "@/components/is-empty";
import Pagination from "@/components/pagination/pagination";
import MiniPagination from "@/components/pagination/mini-pagination";
import DEFAULTGOODS from "@/assets/images/goods_default.jpg";
import PAYCHECKED from "@/assets/images/pay_checked.png";
import { mixinUserbehv } from "@/assets/js/userbehv";

export default {
  components: {
    TopHeaderInfo,
    TopLogo,
    RightNav,
    BottomContent,
    HomeNav,
    AddressTree,
    IsEmpty,
    Pagination,
    MiniPagination
  },
  data() {
    return {
      productsList: [],
      currentPage: 1,
      pageCount: 1,
      minKeyword: "",
      currentFilter: 0,
      priceFilter: 0,
      discountFilter: 0,
      discount_zone: false,
      minPrice: "",
      maxPrice: "",
      columns: [],
      curCategory: "",
      curCategories: "",
      category: "",
      letterArr: ["所有品牌"],
      isShowSelectAddress: false,
      address: "",
      hasMore: true,
      isEmpty: false,
      cartNumber: 0,
      defaultGoods: DEFAULTGOODS,
      checkAll: [],
      brands_name: [], //品牌选中
      brandNames: [],
      all_categroy: [],
      small_categroy: [], //分类选中
      hideWarp: false,
      changeMore: false, //分类显示
      changeBrand: false,
      category_id: null,
      flag: true,
      search: "",
      discount: [],
      discounts: [{ label: "七折", value: 7 }],
      all_rates: [], //折扣分类
      rates: [], //已选折扣
      filterNum: "400px",
      type: "",
      productLoading: false,
      categoryArr: [],
      all_factory_ships: [],
      filter_factory_ships: [],
      filter_brand_names_specific: "",
      letterSearchList: [], //品牌字母索引搜索
      letterSearchActivedIndex: 0,
      advancedOptionsActive: "",
      isOptionLeave: true,
      isOptionListLeave: true,
      filterBoxObj: {}, //筛选
      payBg: PAYCHECKED,
      checkAllLabel: [], //平台label
      ratesLabel: [], //折扣label
      attrs: [], //高级选项data
      filter_attrs: [], //高级选项 传参值
      oneLevelClassify: [], //一级分类list
      twoLevelClassify: [], //二级分类list
      isFiltersShow: true, //是否展示筛选
      selected_postage: false
    };
  },
  watch: {
    $route(val) {
      this.currentPage = 1;
      this.checkAll = [];
      this.checkAllLabel = [];
      this.small_categroy = [];
      this.oneLevelClassify = [];
      this.twoLevelClassify = [];
      this.brands_name = [];
      this.filterBoxObj = {};
      this.filter_attrs = [];
      this.rates = [];
      this.ratesLabel = [];
      this.productsList = [];
      this.flag = true;
      this.hasMore = true;
      this.selected_postage = false;
      this.type = this.$route.query.type;
      if (this.type == "discount") {
        this.rates = this.$route.query.Rate_id
          ? this.$route.query.Rate_id.split(",")
          : [];
      } else if (this.type == "sbzcate") {
        this.checkAll.push("0");
      } else if (this.type == "jdcate") {
        this.checkAll.push("258");
      } else if (this.type == "sncate") {
        this.checkAll.push("631");
      } else if (this.type == "wycate") {
        this.checkAll.push("744");
      }
      if (this.$route.query.filter_brand_names_specific) {
        this.filter_brand_names_specific = JSON.parse(
          this.$route.query.filter_brand_names_specific
        );
      }
      if (val.query.serach != "") {
        // this.initData();
        this.clearFilter(
          this.$route.query.filter_brand_names_specific ? false : true
        );
      }
      if (val.query.type) {
        this.category.map(item => {
          if (item.type === val.query.type) {
            this.curCategory = item;
            this.curCategories = item.categories.slice(0, 6);
          }
        });
      }
      this.category_id = this.$route.query.category_id;
      this.categoryArr = [];
      if (this.category_id) {
        this.getCategoryArr(this.category_id);
      }
      this.search = this.$route.query.search;
      Object.keys(this.$route.query).forEach(key => {
        if (
          key === "filterBoxObj" ||
          key === "checkAll" ||
          key === "rates" ||
          key === "brands_name" ||
          key === "small_categroy" ||
          key === "filter_attrs"
        ) {
          this[key] = JSON.parse(this.$route.query[key]);
        }
      });
      if (this.search) {
        this.serach();
      } else {
        this.getCategory();
        this.initData();
      }
    },
    filter_factory_ships: {
      handler(newVal) {
        if (!newVal[0]) return;
        for (let i = 0; i < this.all_factory_ships.length; i++) {
          if (this.all_factory_ships[i].value == newVal[0]) {
            this.$nextTick(() => {
              let new_ship = this.all_factory_ships[i];
              this.all_factory_ships.splice(i, 1);
              this.all_factory_ships.unshift(new_ship);
              return;
            });
          }
        }
      },
      deep: true
    }
  },
  computed: {
    getFilterOption() {
      return function(value) {
        switch (value) {
          case "checkAll":
            return "平台";
          case "rates":
            return "折扣";
          // case "small_categroy":
          //   return "分类";
          case "brands_name":
            return "品牌";
          default:
            return `${value}`;
        }
      };
    },
    calculatePosition() {
      return function(index, length) {
        let row = Math.ceil(length / 8);
        for (var i = row; i > 0; i--) {
          if (index >= 8 * (i - 1) && index < 8 * i) {
            switch (row - i) {
              case 0:
                return "-8px";
              case 1:
                return "-42px";
              case 2:
                return "-77px";
            }
          }
        }
      };
    }
  },
  mounted() {
    this.category_id = this.$route.query.category_id;
    this.categoryArr = [];
    if (this.category_id) {
      this.getCategoryArr(this.category_id);
    }
    this.type = this.$route.query.type;
    if (this.type == "discount") {
      this.rates = this.$route.query.Rate_id
        ? this.$route.query.Rate_id.split(",")
        : [];
    } else if (this.type == "sbzcate") {
      this.checkAll.push("0");
    } else if (this.type == "jdcate") {
      this.checkAll.push("258");
    } else if (this.type == "free") {
      this.selected_postage = true;
    }
    if (sessionStorage.getItem("activityId")) {
      this.$reqGet(
        "api/store/activities/" + sessionStorage.getItem("activityId")
      ).then(res => {
        if (res.data.data.products.discount_zone) {
          this.discount_zone = res.data.data.products.discount_zone;
        }
      });
    }
    // if (!this.$util.getLocalStorage("sbzRegion").sbzRegion) {
    //   this.$util.setLocalStorage({
    //     sbzRegion: JSON.stringify({
    //       label: "上海 静安区 南京西路街道",
    //       value: "2_2817_61075"
    //     })
    //   });
    // }
    if (!this.$util.getLocalStorage("sbzRegion").sbzRegion) {
      let sbzRegion = {
        label: "上海 静安区 ",
        value: "2_2817_"
      };
      this.getAreaList(2817).then(res => {
        console.log(res);
        sbzRegion.label += res.name;
        sbzRegion.value += res.id;
        this.$util.setLocalStorage({
          sbzRegion: JSON.stringify(sbzRegion)
        });
        this.address = sbzRegion.label;
      });
    } else {
      this.address = JSON.parse(
        this.$util.getLocalStorage("sbzRegion").sbzRegion
      ).label;
    }
    this.search = this.$route.query.search;
    Object.keys(this.$route.query).forEach(key => {
      if (
        key === "filterBoxObj" ||
        key === "checkAll" ||
        key === "rates" ||
        key === "brands_name" ||
        key === "small_categroy" ||
        key === "filter_attrs"
      ) {
        this[key] = JSON.parse(this.$route.query[key]);
      }
    });
    if (this.search) {
      this.serach();
    } else {
      this.getCategory();
      this.initData(true);
    }
  },
  created() {
    // window.onscroll = this.loadMore;
  },
  mixins: [mixinUserbehv],
  methods: {
    reateChange(flag, label) {
      if (label === "全部") {
        if (flag) {
          this.rates = [];
          this.all_rates.map(item => {
            this.rates.push(item.value);
          });
        } else {
          this.rates = [];
        }
      }
    },
    goCategory(item) {
      if (!item) {
        this.$router.push({ name: "index" });
      } else {
        this.$router.push({
          name: "products-list",
          query: { type: this.type, category_id: item.category_id }
        });
      }
    },
    getCategoryArr(category_id) {
      if (!window.open_category[category_id]) {
        setTimeout(() => {
          this.getCategoryArr(category_id);
        }, 1000);
        return;
      }
      this.categoryArr.push(window.open_category[category_id]);
      if (window.open_category[category_id].parent_id != 0) {
        this.getCategoryArr(window.open_category[category_id].parent_id);
      } else {
        this.categoryArr.reverse();
      }
    },
    isFalse(price, special) {
      let oPrice = parseFloat(price);
      let oSpecial = parseFloat(special);
      if (oPrice > oSpecial) {
        return true;
      }
      return false;
    },
    // 分页组件跳转方法
    handleCurrentChange(val) {
      this.currentPage = val;
      this.initData();
    },
    setFilterNum() {
      this.filterNum = this.filterNum === "0px" ? "400px" : "0px";
    },
    clearCheck() {
      let query = {
        ...this.$route.query
      };
      Object.keys(query).forEach(key => {
        if (
          key === "filterBoxObj" ||
          key === "checkAll" ||
          key === "rates" ||
          key === "brands_name" ||
          key === "small_categroy" ||
          key === "filter_attrs"
        ) {
          this.$delete(query, key);
        }
      });
      if (query.Rate_id) {
        delete query.Rate_id;
      }
      this.changeLink(query);

      // this.isFiltersShow = true;
      // this.checkAll = [];
      // this.checkAllLabel = [];
      // this.filterBoxObj = {};
      // this.filter_attrs = [];
      // this.rates = [];
      // this.ratesLabel = [];
      // this.brands_name = [];
      // this.small_categroy = [];
      // this.oneLevelClassify = [];
      // this.twoLevelClassify = [];
      // this.clearFilter(false);
      // this.initData();
      // this.getCategory();
      // this.changeBrand = false;
      // this.changeMore = false;
    },
    clearCategory() {
      let query = {
        ...this.$route.query
      };
      if (query.category_id) {
        delete query.category_id;
      }
      if (query.type) {
        delete query.type;
      }
      this.changeLink(query);
    },
    serach() {
      this.currentPage = 1;
      this.flag = true;
      this.productsList = [];
      this.initData();
      this.getCategory();
      //搜索之后筛选不清空
      //this.checkAll = [];
      //this.brands_name = [];
      //this.small_categroy = [];
    },
    initData(isFirstRequest = false) {
      this.productLoading = true;
      setTimeout(() => {
        this.productLoading = false;
      }, 3000);
      let obj = { page: this.currentPage };
      if (this.$route.query.request_id) {
        obj.request_id = this.$route.query.request_id;
      }
      if (this.minPrice) {
        obj.price_min = this.minPrice;
      }
      if (this.checkAll.length > 0) {
        obj.filter_suppliers_ids = this.checkAll.join(",");
      }
      if (this.$route.query.id) {
        obj.filter_cat_ids = obj.filter_cat_ids
          ? obj.filter_cat_ids + "," + this.$route.query.id
          : this.$route.query.id;
      }
      if (this.small_categroy.length > 0) {
        obj.filter_cat_ids = this.small_categroy.join(",");
      }
      if (this.brands_name.length > 0) {
        obj.filter_brand_names = this.brands_name.join("|");
      } else if (
        this.filter_brand_names_specific &&
        this.brands_name.length === 0
      ) {
        obj.filter_brand_names = this.filter_brand_names_specific;
      }
      if (this.rates.length > 0) {
        obj.filter_rates = this.rates.join(",");
      }
      if (this.type == "discount" && !obj.filter_rates && isFirstRequest) {
        obj.filter_rates = this.$route.query.Rate_id;
      }
      // || this.minKeyword
      if (this.$route.query.search) {
        obj.search = this.$route.query.search;
      }
      if (this.$route.query.category_id) {
        obj.category = this.$route.query.category_id;
      }
      if (this.maxPrice) {
        obj.price_max = this.maxPrice;
      }
      if (this.filter_factory_ships.length > 0) {
        obj.filter_factory_ships = this.filter_factory_ships.join(",");
      }

      if (this.$route.query.price_min) {
        obj.price_min = this.$route.query.price_min;
      }
      if (this.$route.query.price_max) {
        obj.price_max = this.$route.query.price_max;
      }

      if (this.currentFilter === 1) {
        obj.sort = "sale_num";
        obj.order = "desc";
      }
      if (this.currentFilter === 2) {
        obj.sort = "price";
        if (this.priceFilter === 0) {
          obj.order = "desc";
        } else {
          obj.order = "asc";
        }
      }
      if (this.currentFilter === 3) {
        obj.sort = "date_added";
        obj.order = "desc";
      }
      if (this.currentFilter === 4) {
        obj.sort = "good_rate";
        obj.order = "desc";
      }
      if (this.currentFilter === 5) {
        obj.sort = "irt";
        if (this.discountFilter === 0) {
          obj.order = "desc";
        } else {
          obj.order = "asc";
        }
      }
      if (this.selected_postage) {
        obj.filter_free_shipping = 1;
      }
      obj.filter_attrs = this.filter_attrs.join("###");
      this.$reqGet("api/store/product", obj).then(res => {
        if (obj.search) {
          sessionStorage.setItem("trace_info", res.data.data.ops_request_misc);
          sessionStorage.setItem("rn", res.data.data.request_id);
        }
        this.productsList = [];
        this.productLoading = false;
        this.hasMore = res.data.data.has_more;
        if (res.data.status == 200) {
          this.pageCount = res.data.data.total_page;
          if (res.data.data.products) {
            let filterLen = res.data.data.products.filter(
              item => item.can_buy_status === 1
            );
            window.scrollTo(0, 0);
            if (obj.page !== 1 && filterLen.length === 0) {
              this.isEmpty = true;
              return;
            }
            if (filterLen.length !== 0) {
              this.productsList = filterLen;
            } else {
              this.productsList = res.data.data.products;
            }
            if (this.productsList.length == 0) {
              this.isEmpty = true;
            } else {
              this.isEmpty = false;
            }
          }
        }
      });
    },
    changePriceFilter() {
      if (this.priceFilter === 1) {
        this.priceFilter = 0;
      } else {
        this.priceFilter = 1;
      }
    },
    loadMore() {
      let scrollHeight = Math.max(
        document.documentElement.scrollHeight,
        document.body.scrollHeight
      );
      //滚动条滚动距离
      let scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;
      //窗口可视范围高度
      let clientHeight =
        window.innerHeight ||
        Math.min(
          document.documentElement.clientHeight,
          document.body.clientHeight
        );
      if (navigator.userAgent.indexOf("Edge") > -1) {
        clientHeight += 20;
      }
      // 340为footer的高度
      if (clientHeight + scrollTop >= scrollHeight - 340) {
        if (this.hasMore) {
          this.initData();
        }
      }
    },
    clearFilter(isClearFilterBrandNamesSpecific = true) {
      this.currentPage = 1;
      this.flag = true;
      // this.minPrice = "";
      // this.maxPrice = "";
      // this.keyword = "";
      this.productsList = [];
      this.filter_factory_ships = [];
      if (isClearFilterBrandNamesSpecific) {
        this.filter_brand_names_specific = "";
      }
    },
    showSelectAddress() {
      this.isShowSelectAddress = !this.isShowSelectAddress;
    },
    setAddress(sbzRegion) {
      this.isShowSelectAddress = false;
      this.address = sbzRegion.label;
      this.$util.setLocalStorage({ sbzRegion: JSON.stringify(sbzRegion) });
      this.initData();
    },
    goToGoosDetail(id, sku) {
      this.setUserbehv(id, "click", sku, 1);
      let routeUrl = this.$router.resolve({
        path: "/productDetail",
        query: { type: this.curCategory.type, product_id: id }
      });
      window.open(routeUrl.href, "_blank");
    },
    addToCart(id, minimum, sku) {
      this.setUserbehv(id, "cart", sku, 1);
      this.$reqPost("api/store/cart", { id: id, qty: minimum || 1 }).then(
        res => {
          if (res.data.status == 200) {
            this.open();
            this.$bus.emit("get-cartNum");
          }
        }
      );
    },
    open() {
      this.$message({ message: "添加至购物车成功", type: "success" });
    },
    getCategory() {
      let obj = {};
      if (this.checkAll.length > 0) {
        obj.filter_suppliers_ids = this.checkAll.join(",");
      }
      if (this.$route.query.id) {
        obj.filter_cat_ids = obj.filter_cat_ids
          ? obj.filter_cat_ids + "," + this.$route.query.id
          : this.$route.query.id;
      }
      if (this.small_categroy.length > 0) {
        obj.filter_cat_ids = this.small_categroy.join(",");
      }
      if (this.brands_name.length) {
        obj.filter_brand_names = this.brands_name.join("|");
      } else if (
        this.filter_brand_names_specific &&
        this.brands_name.length === 0
      ) {
        obj.filter_brand_names = this.filter_brand_names_specific;
      }
      if (this.rates.length > 0) {
        obj.filter_rates = this.rates.join(",");
      }
      if (this.$route.query.search || this.minKeyword) {
        obj.search = this.$route.query.search || this.minKeyword;
      }
      if (this.$route.query.category_id) {
        obj.category = this.$route.query.category_id;
      }
      if (this.$route.query.request_id) {
        obj.request_id = this.$route.query.request_id;
      }
      if (this.selected_postage) {
        obj.filter_free_shipping = 1;
      }
      obj.filter_attrs = this.filter_attrs.join("###");
      this.$reqGet("api/store/product/agg", obj).then(res => {
        if (res.data.status == 200) {
          if (this.rates.length > 0 && !this.filterBoxObj["rates"]) {
            let ratesLabelStr = [];
            res.data.data.all_rates.forEach(item => {
              this.rates.forEach(item2 => {
                if (item.value == item2) {
                  ratesLabelStr.push(item.label);
                }
              });
            });
            this.filterBoxObj["rates"] = { name: ratesLabelStr.join(",") };
          }
          // 分类筛选
          if (obj.filter_cat_ids) {
            this.$reqGet("api/store/product/agg", {
              search: obj.search
            }).then(res2 => {
              this.oneLevelClassify = res2.data.data.categories;
              for (var i = 0; i < res2.data.data.categories.length; i++) {
                if (res2.data.data.categories[i].value == obj.filter_cat_ids) {
                  this.twoLevelClassify = [];
                  let oneLevelStartValue = this.oneLevelClassify[i];
                  this.oneLevelClassify.splice(i, 1);
                  this.oneLevelClassify.unshift(oneLevelStartValue);
                  return;
                } else {
                  for (
                    var j = 0;
                    j < res2.data.data.categories[i].children.length;
                    j++
                  ) {
                    if (
                      res2.data.data.categories[i].children[j].value ==
                      obj.filter_cat_ids
                    ) {
                      this.twoLevelClassify =
                        res2.data.data.categories[i].children;
                      let oneLevelStartValue = this.oneLevelClassify[i];
                      this.oneLevelClassify.splice(i, 1);
                      this.oneLevelClassify.unshift(oneLevelStartValue);
                      let twoLevelStartValue = this.twoLevelClassify[j];
                      this.twoLevelClassify.splice(j, 1);
                      this.twoLevelClassify.unshift(twoLevelStartValue);
                      return;
                    }
                  }
                }
              }
            });
          }

          //配送方式
          this.all_factory_ships = [];
          res.data.data.all_factory_ships &&
            res.data.data.all_factory_ships.map(item => {
              if (
                item.label !== "" &&
                item.value !== "0" &&
                item.value !== "1"
              ) {
                this.all_factory_ships.push(item);
              }
            });

          //高级选项
          for (let i in this.filter_attrs) {
            res.data.data.attrs = res.data.data.attrs.filter(item => {
              return !this.filter_attrs[i].includes(item.value);
            });
          }
          this.attrs = res.data.data.attrs || [];

          this.old_categroy = res.data.data.all_categories || []; //老数据
          this.old_brand_names = res.data.data.hot_brand_names || [];
          this.category = res.data.data.all_suppliers || [];
          this.all_rates = res.data.data.all_rates.reverse();
          if (this.all_rates.length > 0) {
            this.all_rates.unshift({ label: "全部", value: "all" });
          }
          this.all_categroy = this.old_categroy.slice(0, 9);
          this.brandNames = this.old_brand_names.slice(0, 16);
          if (
            this.brandNames.length == 1 &&
            this.brandNames[0].compel_filtrate_brand_name_status == "1"
          ) {
            this.filter_brand_names_specific = "sbz_brand_name";
            this.brands_name.push(this.brandNames[0].value);
            this.filterBoxObj["brands_name"] = {
              name: this.brandNames[0].value
            };
          }
          if (
            this.category.length <= 0 &&
            this.all_categroy.length <= 0 &&
            this.brandNames.length <= 0
          ) {
            this.hideWarp = true;
            this.$message.error("暂无商品，请重置分类!");
          } else {
            this.hideWarp = false;
          }

          // 首字母索引筛选
          this.letterSearchList = [];
          this.letterSearchActivedIndex = 0;
          this.changeBrand = false;
          if (res.data.data.all_brands && res.data.data.all_brands.length > 0) {
            this.letterSearchList.push({
              py: "所有品牌",
              data: res.data.data.all_brands
            });
          }
          res.data.data.py_group_brands &&
            res.data.data.py_group_brands.forEach(item => {
              this.letterSearchList.push(item);
            });
        }
      });
    },
    moreCategroy() {
      if (!this.changeMore) {
        this.changeMore = true;
        this.all_categroy = this.old_categroy;
      } else {
        this.changeMore = false;
        this.all_categroy = this.all_categroy.slice(0, 9);
      }
    },
    moreBrandName() {
      if (this.changeBrand) {
        this.changeBrand = false;
        this.brandNames = this.brandNames.slice(0, 16);
        this.letterSearchActivedIndex = 0;
      } else {
        this.changeBrand = true;
        this.brandNames = this.old_brand_names;
      }
    },
    // 品牌搜索字母索引划过事件
    hoverLetterSearch(index) {
      this.letterSearchActivedIndex = index;
    },
    mouseleaveEvent(part, e) {
      if (part == "optionsList") {
        this.isOptionListLeave = true;
      } else {
        this.isOptionLeave = true;
      }
      let currentDom = e.currentTarget;
      setTimeout(() => {
        if (this.isOptionLeave && this.isOptionListLeave) {
          if (currentDom.tagName == "LI") {
            if (!currentDom.parentNode) return;
            // if (!currentDom.parentNode.parentNode.nextElementSibling) return;
            currentDom =
              currentDom.parentNode.parentNode.nextElementSibling.childNodes[
                currentDom.getAttribute("data-index")
              ];
          }
          currentDom.classList.contains("multiple")
            ? currentDom.classList.remove("multiple")
            : "";
          this.advancedOptionsActive = "";
        }
      }, 1000);
      this.clearFilterDom();
    },
    mouseEnterEvent(part, type) {
      if (part == "optionsList") {
        this.isOptionListLeave = false;
      } else {
        this.isOptionLeave = false;
      }
      this.advancedOptionsActive = type;
    },
    changeCheckBox(e) {
      this.clearData();
      e.currentTarget.previousElementSibling.parentNode.parentNode.classList.add(
        "multiple"
      );
    },
    cancelCheckBox(e, type) {
      if (type) {
        this[type] = [];
        this.clearData();
      } else {
        this.clearFilterDom();
      }
    },
    comfirmCheckBox(e, type) {
      this.filterBoxObj[type] = {
        name: this[`${type}Label`]
          ? this[`${type}Label`].join(",")
          : this[type].join(",")
      };
      let query = {
        ...this.$route.query
      };
      query.filterBoxObj = JSON.stringify(this.filterBoxObj);
      query[type] = JSON.stringify(this[type]);
      this.changeLink(query);
    },
    // 高级选项
    comfirmCheckBox2(e, type) {
      let arr = [];
      e.currentTarget.parentNode.parentNode.childNodes[0].childNodes[0].childNodes.forEach(
        item => {
          if (item.classList.contains("active")) {
            arr.push(item.innerText);
          }
        }
      );
      this.filterBoxObj[type] = {
        name: arr.join(",")
      };
      let query = {
        ...this.$route.query
      };
      query.filterBoxObj = JSON.stringify(this.filterBoxObj);
      query.filter_attrs = JSON.stringify(this.filter_attrs);
      this.changeLink(query);
    },
    clickOption(e, item, type) {
      if (
        e.currentTarget.parentNode.parentNode.parentNode.classList.contains(
          "multiple"
        )
      ) {
        if (this[type].includes(item.value)) {
          e.currentTarget.classList.remove("active");
          this[type].splice(this[type].indexOf(item.value), 1);
          item.label &&
            this[`${type}Label`].splice(
              this[`${type}Label`].indexOf(item.label),
              1
            );
        } else {
          e.currentTarget.classList.add("active");
          this[type].push(item.value);
          item.label && this[`${type}Label`].push(item.label);
        }
      } else {
        this[type].push(item.value);
        this.filterBoxObj[type] = {
          name: item.label ? item.label : item.value
        };
        let query = {
          ...this.$route.query
        };
        query.filterBoxObj = JSON.stringify(this.filterBoxObj);
        query[type] = JSON.stringify(this[type]);
        this.changeLink(query);
      }
    },
    // 高级选项
    clickOption2(e, item, type) {
      if (
        e.currentTarget.parentNode.parentNode.parentNode.classList.contains(
          "multiple"
        )
      ) {
        if (e.currentTarget.classList.contains("active")) {
          e.currentTarget.classList.remove("active");
          this.filter_attrs = this.filter_attrs.filter(item => {
            return !item.includes(item.value);
          });
        } else {
          e.currentTarget.classList.add("active");
          this.filter_attrs.push(`${type}!!${item.value}`);
        }
      } else {
        this.filter_attrs.push(`${type}!!${item.value}`);
        this.filterBoxObj[type] = {
          name: item.value
        };
        let query = {
          ...this.$route.query
        };
        query.filterBoxObj = JSON.stringify(this.filterBoxObj);
        query.filter_attrs = JSON.stringify(this.filter_attrs);
        this.changeLink(query);
      }
    },
    //选择分类
    clickClassifyOption(item, index) {
      if (index == 0) return;
      this.small_categroy = [];
      this.small_categroy.push(item.value);
      let query = {
        ...this.$route.query
      };
      query.small_categroy = JSON.stringify(this.small_categroy);
      this.changeLink(query);
    },
    closeOption(item, key) {
      let query = {
        ...this.$route.query
      };
      let filterBoxObj = query.filterBoxObj
        ? JSON.parse(query.filterBoxObj)
        : {};
      this.$delete(query, this[key] ? key : "filter_attrs");
      this.$delete(filterBoxObj, key);
      query.filterBoxObj = JSON.stringify(filterBoxObj);
      if (query.filterBoxObj === "{}") {
        this.$delete(query, "filterBoxObj");
      }
      if (key === "rates" && query.Rate_id) {
        delete query.Rate_id;
      }
      this.changeLink(query);
    },
    // 清空数据
    clearData() {
      if (!this.filterBoxObj["checkAll"]) this.checkAll = [];
      if (!this.filterBoxObj["brands_name"]) this.brands_name = [];
      if (!this.filterBoxObj["rates"]) this.rates = [];
      // 清空选中的样式
      let optionBoxDom = document.getElementsByClassName("optionBox");
      for (var i = 0; i < optionBoxDom.length; i++) {
        if (optionBoxDom[i].classList.contains("multiple")) {
          optionBoxDom[i].classList.remove("multiple");
          let ulDom;
          if (
            optionBoxDom[i].childNodes[0].classList.contains("letterSearch")
          ) {
            if (this.changeBrand) this.moreBrandName();
            ulDom = optionBoxDom[i].childNodes[2].childNodes;
          } else {
            ulDom = optionBoxDom[i].childNodes[0].childNodes;
          }
          if (ulDom.length == 0) return;
          for (var j = 0; j < ulDom[0].childNodes.length; j++) {
            if (ulDom[0].childNodes[j].classList.contains("active")) {
              ulDom[0].childNodes[j].classList.remove("active");
            }
          }
        }
      }
    },
    // 清空高级筛选选中的样式
    clearFilterDom() {
      let filter_attrs = [];
      Object.keys(this.filterBoxObj).forEach(item2 => {
        this.filter_attrs.forEach(item => {
          if (item.includes(item2)) {
            filter_attrs.push(item);
          }
        });
      });
      this.filter_attrs = filter_attrs;
      let contentAdvancedOptionsDom = document.getElementsByClassName(
        "contentAdvancedOptions-item"
      );
      for (var n = 0; n < contentAdvancedOptionsDom.length; n++) {
        if (contentAdvancedOptionsDom[n].classList.contains("multiple")) {
          contentAdvancedOptionsDom[n].classList.remove("multiple");
          let ulDom =
            contentAdvancedOptionsDom[n].childNodes[0].childNodes[0].childNodes;
          for (var m = 0; m < ulDom.length; m++) {
            if (ulDom[m].classList.contains("active")) {
              ulDom[m].classList.remove("active");
            }
          }
        }
      }
    },
    changeLink(query) {
      query.filter_brand_names_specific = JSON.stringify(
        this.filter_brand_names_specific
      );
      this.$router.push({
        path: this.$route.path,
        query: JSON.parse(JSON.stringify(query))
      });
    },
    async getAreaList(city) {
      return await this.$reqGet("api/store/address/area_list/" + city).then(
        res => {
          return res.data.data[0];
        }
      );
    }
  },
  beforeDestroy() {
    window.onscroll = null;
  }
};
</script>

<style lang="less" scoped>
.mypage-wrap {
  font-size: 14px;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  // position: relative;
  // left: 10%;
  position: absolute;
  right: 0;
  top: 20px;
}
.products-wrap {
  background-color: #fff;
}
.filters {
  // height: 400px;
  // overflow: hidden;
  transition: all linear 0.3s;
}
.category_wrap {
  // padding: 10px 0;
  // min-height: 200px;
  border-top: 1px solid gainsboro;
  .marginTop {
    // margin: 10px 0;
    position: relative;
    line-height: 36px;
    .letterSearch {
      display: flex;
      margin-bottom: 5px;
      margin-top: 5px;
      li {
        padding: 0 8px;
        height: 20px;
        line-height: 20px;
        border: 1px solid #fff;
        cursor: default;
        text-align: center;
        color: #606266;
        &.actived {
          border-color: #e4393c;
          color: #e4393c;
        }
        &:hover {
          border-color: #e4393c;
          color: #e4393c;
        }
      }
    }

    &.optionBox {
      .optionlist {
        display: flex;
        justify-content: space-between;
        align-items: center;
        // position: relative;
        ul {
          display: flex;
          flex-wrap: wrap;
          align-content: start;
          padding-right: 60px;
          // max-height: 113px;
          overflow: auto;
          li {
            display: flex;
            align-items: center;
            margin-right: 30px;
            cursor: pointer;
            &.classify {
              width: 100px;
              overflow: hidden;
              white-space: nowrap;
              text-overflow: ellipsis;
              margin-right: 15px;
            }
            b {
              display: none;
            }
          }
          &.brandList {
            margin: 5px 120px 5px 0;
            max-height: 200px;
            overflow: auto;
            padding-right: 0;
            li {
              width: 116px;
              height: 48px;
              background: #ffffff;
              border: 1px solid #e4e4e4;
              background-repeat: round;
              margin: 0px;
              overflow: hidden;
              white-space: nowrap;
              display: block;
              text-align: center;
              line-height: 48px;

              &:hover {
                cursor: pointer;
                border-color: #e2343f;
                color: #e2343f;
                img {
                  display: none;
                }
              }
              img {
                margin: 10%;
                width: 77%;
                height: 55%;
              }
            }
          }
        }
        span {
          width: 48px;
          height: 24px;
          background: #ffffff;
          border-radius: 2px;
          border: 1px solid #e4e4e4;
          text-align: center;
          line-height: 24px;
          cursor: pointer;
          position: absolute;
          top: 5px;
          right: 0;
        }
      }
      .optionBtns {
        display: none;
        justify-content: center;
        margin-bottom: 5px;
        .el-button {
          margin-right: 20px;
        }
      }
    }
    &.multiple {
      .optionlist {
        ul {
          li {
            i {
              width: 18px;
              height: 18px;
              border-radius: 2px;
              border: 1px solid #b2b2b2;
              margin-right: 8px;
            }
            &.active > i {
              border-color: #409eff;
              background: #409eff;
              b {
                display: block;
                color: #ffffff;
                position: relative;
                left: 2px;
                top: 2px;
              }
            }
          }
        }
        span {
          display: none;
        }
      }
      .optionBtns {
        display: flex;
      }
    }
  }
  .line {
    height: 1px;
    background: #e4e4e4;
  }
  .advancedOptions {
    // margin: 10px 0;
    & > ul {
      display: flex;
      // height: 36px;
      align-items: center;
      flex-wrap: wrap;
      & > li {
        border: 1px solid #e4e4e4;
        background: #fff;
        height: 23px;
        padding: 0 8px;
        width: 100px;
        display: flex;
        align-items: center;
        justify-content: center;
        margin: 5px;
        &.active {
          cursor: pointer;
          border-bottom: medium none;
          position: relative;
          height: 24px;
          z-index: 3;
          border-color: #fc6823;
          color: #e33f4a;
          i {
            &:before {
              content: "\E6E1";
            }
          }
        }
        span.name {
          width: 84px;
          height: 23px;
          overflow: hidden;
          display: -webkit-box;
          text-overflow: ellipsis;
          -webkit-line-clamp: 1;
          -webkit-box-orient: vertical;
          text-align: center;
          line-height: 23px;
        }
      }
    }
  }
  .contentAdvancedOptions {
    margin-top: -7px;
    position: absolute;
    bottom: 0;
    left: 0;
    z-index: 2;
    .contentAdvancedOptions-item {
      display: none;
      width: 1200px;
      border: 1px solid #fc6823;
      box-sizing: border-box;
      flex-direction: column;
      position: absolute;
      top: -8px;
      background: #fff;
      &.multiple {
        .contentAdvancedOptions-list {
          ul {
            li {
              i {
                width: 18px;
                height: 18px;
                border-radius: 2px;
                border: 1px solid #b2b2b2;
                margin-right: 8px;
              }
              &.active > i {
                border-color: #409eff;
                background: #409eff;
                b {
                  display: block;
                  color: #ffffff;
                  position: relative;
                  left: 2px;
                  top: 2px;
                }
              }
            }
          }
          span {
            display: none;
          }
        }
        .contentAdvancedOptions-btn {
          display: flex;
        }
      }
      .contentAdvancedOptions-list {
        display: flex;
        justify-content: space-between;
        position: relative;
        width: 98%;
        padding: 12px;
        ul {
          display: flex;
          flex-wrap: wrap;
          li {
            display: flex;
            align-items: center;
            margin-right: 40px;
            cursor: pointer;
            line-height: 25px;
            b {
              display: none;
            }
          }
        }
        span {
          width: 48px;
          height: 24px;
          background: #ffffff;
          border-radius: 2px;
          border: 1px solid #e4e4e4;
          text-align: center;
          line-height: 24px;
          cursor: pointer;
          flex-shrink: 0;
        }
      }
      .contentAdvancedOptions-btn {
        display: none;
        justify-content: center;
        margin-bottom: 15px;
        .el-button {
          margin-right: 20px;
        }
      }
    }
  }
  > .el-col:last-of-type(1) {
    margin: 0;
  }
  img {
    width: 150px;
    height: 70px;
  }
}
.product-list {
  // min-height: 400px;
  > .el-col {
    cursor: pointer;
    background-color: #fff;
    border: 1px solid #eee;
    position: relative;
    &:hover {
      box-shadow: -2px 0px 5px rgba(0, 0, 0, 0.2);
    }
    > div:first-child {
      text-align: center;
      height: 250px;
    }
    .product-img {
      width: 220px;
      height: 220px;
      padding: 15px 0;
    }
    .goods-description {
      font-size: 16px;
      line-height: 21px;
      color: #000;
      height: 42px;
      overflow: hidden;
      display: -webkit-box;
      text-overflow: ellipsis;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
      padding: 0 15px;
      .identify {
        display: inline-block;
        color: #fff;
        height: 21px;
        line-height: 18px !important;
        white-space: nowrap;
        text-align: center;
        border-radius: 4px;
        width: 70px;
        .supply-text {
          font-size: 12px;
          font-weight: 300;
        }
      }
      .sbz {
        background: #52b6fc;
      }
      .jd {
        background: #ef000e;
      }
      .sn {
        background: #f8b62f;
      }
      .wy {
        background: #c18d4d;
      }
      .tm {
        background: #ff482c;
      }
    }

    .goods-distribution {
      padding: 0 15px 15px;
      height: 20px;
      .supply-text {
        line-height: 16px !important;
        white-space: nowrap;
        text-align: center;
        border-radius: 2px;
        font-weight: 500;
        margin-right: 3px;
        &.jd {
          border: 1px solid #f54029;
          color: #f53415;
        }
        &.suning {
          border: 1px solid #ff8000;
          color: #ff8000;
        }
        &.by {
          border: 1px solid #ffaf0f;
          color: #ffaf0f;
        }
      }
      .supply-text-jd {
        line-height: 16px !important;
        white-space: nowrap;
        border-radius: 2px;
        background: rgba(245, 65, 41, 0.1);
        color: #f53415;
        display: inline-block;
        padding: 3px;
        font-weight: 500;
      }
    }
    .good-comment {
      color: #999;
      padding: 6px 15px 0;
      height: 25px;
      .comment-highlight {
        color: #e23a41;
      }
    }
    .goods-price {
      color: #e2333f;
      font-size: 18px;
      // padding: 0 15px 15px;
      padding: 0 15px;
      white-space: nowrap;

      .price_format {
        font-size: 14px;
        color: #666;
        text-decoration: line-through;
      }
      .dis_rate_text {
        background: #e23a41;
        font-size: 13px;
        color: #fff;
        padding: 3px;
        border-radius: 2px;
      }
      .el-col:last-child {
        text-align: right;
        .el-button {
          width: 32px;
          height: 32px;
          border-radius: 50%;
          line-height: 34px;
          text-align: center;
          padding: 0;
          background-color: #e2333f;
          border: none;
          .el-icon {
            color: #fff;
            font-size: 18px;
          }
        }
      }
    }
    .not-enough {
      position: absolute;
      top: 75px;
      left: 0;
      right: 0;
      bottom: 0;
      margin: 0 auto;
      width: 100px;
      height: 100px;
    }
  }
}
.el-pagination {
  text-align: right;
  margin-top: 10px;
}
.site-nav {
  padding: 20px 0;
  color: #999;
  font-size: 16px;
  a {
    color: #999;
  }
  a:first-child {
    color: #444;
  }
}
.filterList {
  display: flex;
  align-items: center;
  // height: 50px;
  position: relative;
  flex-wrap: wrap;
  margin-bottom: 10px;
  padding-right: 100px;
  padding-top: 20px;
  min-height: 37px;
  .filterListBox {
    padding: 0 8px;
    height: 24px;
    background: #f5f5f5;
    border-radius: 2px;
    border: 1px solid #e4e4e4;
    font-size: 14px;
    font-weight: 400;
    color: #666666;
    line-height: 24px;
    position: relative;
    display: flex;
    align-items: center;
    margin: 3px 0 3px 15px;
    &:hover {
      cursor: pointer;
      border: 1px solid #e2343f;
      background: #ffffff;
      .el-icon-close {
        color: #e2343f;
      }
    }
    &:before {
      content: ">";
      position: absolute;
      left: -15px;
    }
    .el-icon-close {
      cursor: pointer;
      color: #999999;
    }
    .value {
      color: #e2343f;
      max-width: 150px;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
    }
  }

  .classifyBox {
    position: relative;
    cursor: pointer;
    margin-left: 15px;
    &:before {
      content: ">";
      position: absolute;
      left: -15px;
    }
    .trigger {
      height: 24px;
      background: #ffffff;
      border-radius: 2px;
      border: 1px solid #cccccc;
      font-size: 14px;
      color: #333333;
      line-height: 24px;
      padding: 0 5px;
      position: relative;
      i {
        &:before {
          content: "\E6DF";
        }
      }
    }
    ul {
      display: none;
      position: absolute;
      top: 24px;
      left: 0;
      z-index: 2;
      flex-wrap: wrap;
      width: 340px;
      border: 1px solid #e2343f;
      padding: 12px 8px;
      background: #ffffff;
      li {
        width: 30%;
        margin-right: 3%;
        font-size: 12px;
        margin-top: 4px;
        margin-bottom: 4px;
      }
    }
    &:hover {
      .trigger {
        border: 1px solid #e2343f;
        border-bottom: #ffffff;
        z-index: 3;
        color: #e2343f;
        i {
          &:before {
            content: "\E6E1";
          }
        }
      }

      ul {
        display: flex;
      }
    }
  }
  .clear-category {
    color: #999999;
    cursor: pointer;
    margin-left: 6px;
  }
  .emptyFilter {
    width: 72px;
    height: 24px;
    background: #ffffff;
    border-radius: 2px;
    border: 1px solid #cccccc;
    font-size: 14px;
    font-weight: 400;
    color: #999999;
    line-height: 24px;
    text-align: center;
    margin-left: 24px;
    &:hover {
      border: 1px solid #fc6823;
      color: #fc6823;
      cursor: pointer;
    }
  }
  .all {
    cursor: pointer;
    color: #e33f4a;
    padding: 5px 0;
  }
  > .List {
    display: flex;
    > .item {
      margin: 0 5px;
      cursor: pointer;
      > span {
        display: inline-block;
        max-width: 120px;
        white-space: nowrap;
        overflow: hidden;
        color: #e33f4a;
        vertical-align: bottom;
        text-overflow: ellipsis;
      }
    }
  }
  > .search {
    margin: 0 5px;
    > span {
      color: #e33f4a;
    }
  }
  > .clear {
    margin: 0 5px;
    padding: 5px 10px;
    border: 1px solid #ccc;
    cursor: pointer;
  }
  .showFilter {
    font-size: 10px;
    position: absolute;
    right: 0;
    padding: 10px 10px;
    background: #f6f6f6;
    color: #666;
    cursor: pointer;
    > .el-icon-arrow-down {
      font-size: 5px;
    }
  }
  .showFilter:hover {
    color: #e23a41;
  }
}
.cate-nav-wrap {
  .el-row {
    border: 1px solid #ddd;
    border-bottom: none;
  }
  .el-row:last-child {
    border-bottom: 1px solid #ddd;
  }
  .category-name {
    display: inline-block;
    width: 100px;
    min-height: 34px;
    line-height: 34px;
    text-align: center;
    background-color: #f6f6f6;
  }
  .cate-nav {
    display: inline-block;
    // position: relative;
    // left: 100px;
    // top: -26px;
    width: 1000px;

    a {
      font-weight: normal;
      font-size: 13px;
      margin-left: 4px;
      cursor: pointer;
      color: #005d9f;
      &:hover,
      &.actived {
        color: #e2333f;
      }
      &:first-letter {
        color: #999;
      }
    }
  }
}
.filter {
  height: 100px;
  padding: 12px;
  box-sizing: border-box;
  border: 1px solid rgba(221, 221, 221, 1);
  background: rgba(246, 246, 246, 1);
  font-size: 0;
  margin: 10px 0;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  flex-wrap: wrap;
  span {
    font-size: 14px;
    position: relative;
    cursor: pointer;
    border: 1px solid #ccc;
    padding: 2px 5px;
    background-color: #fff;
    white-space: nowrap;
    &.actived {
      background-color: #e2333f;
      color: #fff;
      border: 1px solid #e2333f;
    }
    .el-icon-caret-top,
    .el-icon-caret-bottom {
      position: absolute;
      right: 6px;
      &.actived {
        opacity: 0.6;
      }
    }
    .el-icon-caret-top {
      top: 0;
    }
    .el-icon-caret-bottom {
      bottom: 0;
    }
  }
  .el-input {
    display: inline-block;
    width: 100px;
  }
  .address {
    position: relative;
    display: inline-block;
    font-size: 14px;
    // margin: 0 20px;
    .el-input {
      width: 200px;
    }
    i {
      position: absolute;
      right: 6px;
      top: 5px;
    }
  }
}
.filter-wrap /deep/ .el-input__inner {
  height: 26px;
  line-height: 26px;
  border-radius: 0;
}
.address /deep/ .el-input__inner {
  cursor: pointer;
}
.mysearch-wrap {
  position: relative;
  display: inline-block;
  margin-left: 20px;
  .el-input {
    width: 200px;
    height: 26px;
    line-height: 26px;
    margin-right: 60px;
  }
  .el-input__inner {
    height: 26px;
    line-height: 26px;
  }
  .el-icon-mysearch {
    width: 30px;
    height: 26px;
    position: absolute;
    top: 0;
    left: 200px;
    padding-top: 6px;
    border: 1px solid #ddd;
    z-index: 100;
    font-size: 14px;
    text-align: center;
    color: #6d6d6d;
    cursor: pointer;
    box-sizing: border-box;
  }
  .serach {
    width: 90px;
    height: 26px;
    display: block;
    text-align: center;
    box-sizing: border-box;
  }
}
.mypage-warp {
  position: relative;
  display: inline-block;
  margin-left: 20px;
}
.filter-wrap {
  position: relative;
}
.el-cascader {
  position: absolute;
  left: 276px;
  top: 7px;
  z-index: 900;
  .el-input__inner {
    height: 26px;
    line-height: 26px;
    border-radius: 0;
  }
}

._btn {
  width: 80px;
  height: 30px;
  margin: 40px 10px;
  float: left;
  cursor: pointer;
  text-align: center;
  line-height: 30px;
  border-radius: 5px;
}
._denger {
  border: 1px solid #e33f4a;
  color: #e33f4a;
}
._dengerBg {
  background: #e33f4a;
  color: white;
}
.colWdith {
  /deep/ .el-checkbox__label {
    width: 180px;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
}
.more {
  position: absolute;
  right: 10px;
  top: 0px;
  cursor: pointer;
  width: 60px;
  height: 30px;
  line-height: 30px;
  text-align: center;
  font-size: 10px;
  border: 1px solid gainsboro;
  box-sizing: border-box;
}
.iconImages {
  width: 20px !important;
  height: 20px !important;
}
.maxHeight {
  width: 950px;
  max-height: 70px;
  overflow: auto;
}
.scroll::-webkit-scrollbar {
  width: 10px;
  height: 10px;
}
.scroll::-webkit-scrollbar-thumb {
  border-radius: 10px;
  -webkit-box-shadow: inset 0 0 5px rgba(247, 247, 247, 0.2);
  background: #535353;
}
.scroll::-webkit-scrollbar-track {
  height: 20px;
  -webkit-box-shadow: inset 0 0 1px rgba(247, 247, 247, 0.4);
  background: #ccc;
}
/deep/ .faster > em {
  color: red;
  font-style: normal;
}

// 配送服务样式
.selectDeliveryMode {
  // width: 100px;
  height: 26px;
  margin-left: 10px;
  position: relative;
  z-index: 1;
  background-color: #f6f6f6;
  .el-checkbox-group {
    // position: absolute;
    // top: 0;
    // left: 0;
    height: 24px;
    overflow: hidden;
    line-height: 24px;
    display: flex;
    flex-direction: column;
    border: 1px solid #ccc;
    background-color: #f6f6f6;
    // box-sizing: border-box;
    .el-checkbox {
      margin-right: 10px;
      margin-left: 10px;
      height: 24px;
    }
  }
  &:hover {
    .el-checkbox-group {
      height: auto;
    }
  }
}
.selected-postage {
  font-size: 14px;
  border: 1px solid #ccc;
  padding: 2px 10px;
  height: 26px;
  box-sizing: border-box;
  margin-left: 10px;
}
</style>



// WEBPACK FOOTER //
// src/pages/products/list.vue